import flyer from 'attachments/flyer.jpg'

import {
  FiMapPin,
  FiCalendar,
  FiClock,
  FiMap,
  FiCrosshair
} from 'react-icons/fi'

import {
  RiPinDistanceFill
} from 'react-icons/ri'

const Info = () => {

  return <div className="one air-2x gap-2x info">

    <img className="flyer" src={ flyer } alt="brujxs radioactivxs" />

    <div className="vs gap-2x">
      <FiCalendar />

      <label>
        14 de junio
      </label>
    </div>

    <div className="vs gap-2x">
      <FiClock />

      <label>
        07:00
      </label>
    </div>

    <div className="vs gap-2x">
      <FiMapPin />

      <label>
        <a
          href="https://maps.app.goo.gl/WX8RmorNFp1rubo87"
        >kiosco san juan teacalco</a>
      </label>
    </div>

    <div className="vs gap-2x">
      <RiPinDistanceFill />

      <label>
        32 km
      </label>
    </div>

    <div className="vs gap-2x">
      <FiMap />

      <label>
        <a
          href="/map"
        >mapa de ruta</a>
      </label>
    </div>

    <div className="vs gap-2x">
      <FiCrosshair />

      <label>
        <a
          href="/radar"
        >radar</a>
      </label>
    </div>

  </div>
}

export default Info
